import { Flex } from '@mantine/core'
import styled from 'styled-components'
import { smStyle } from '@/components/Adapter'

export const PriceFaqsStyled = styled(Flex)`
  display: flex;
`

export const PriceFaqsTitleStyled = styled.h2`
  font-style: normal;
  font-size: 20px;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 16px;

  ${smStyle} {
    margin-bottom: 24px;
    font-size: 24px;
  }
`
